import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { AuthVM } from '../../Structure/ViewModels/Auth/AuthVM'
import { Globals } from '../../Structure/Globals/GlobalObs'

const LoginDevice = () => {
    const [vm, setVm] = useState<{viewModel:AuthVM}>({viewModel:Globals.auth})
    const control = vm.viewModel
    useEffect(()=>control.subscribeUpdate(setVm),[])


  return (
        <Container className='h-100'>
            <Row className='h-100 justify-content-center'>
                <Col md={6} className='d-flex flex-column justify-content-center'>
                    <Row className='d-flex justify-content-center justify-content-md-between py-3'>
                        <h4 className='py-4 text-center'>تفعيل المتصفح</h4>
                    </Row>
                    <Row className='d-flex justify-content-center justify-content-md-center py-3'>
                        <Col className='d-flex justify-content-center'  sm={12}>
                            <input type="password" className='input-field my-auto' value={control.DeviceLoginData.password}  onChange={a=>control.DevicePassword = a.target.value} />
                        </Col>
                    </Row>
                    <Row className='d-flex justify-content-center py-5'>
                        <Col className='d-flex justify-content-center'  sm={6}>
                            <button className='my-auto button-I btn-cl-I px-4 py-1' onClick={()=>control.activateDevice()}>تفعيل</button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
  )
}

export default LoginDevice